import { Link } from 'react-router-dom'
import { startLogout } from '../actions/auth'
import { connect } from 'react-redux'
import React from 'react'

 const Header = ({ startLogout }) => (
 
     <div className="header-main">
      <header className="header container">
        <Link className="header-title" to="/" exact={true}>
        <h1 >Expensify</h1>
        </Link>
        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
          <Link to="/analytics" style={{ textDecoration: 'none', color: 'rgb(228, 227, 227)', fontSize: '1.8rem', fontWeight: 500 }}>
            Analytics
          </Link>
          <button className="logout" onClick={startLogout}>Logout</button>
        </div>
      </header>
     </div>
    
);

const mapDispatchToProps = (dispatch) => ({
  startLogout: () => dispatch(startLogout())
})

export default connect(undefined,mapDispatchToProps)(Header)
  

  
  
  